define('gameday-index-gdads/GDIndexAdsComponent',['require','exports','module','jquery','gameday-index-component-base/GDIndexComponentBase','gameday-index-configurator/GamedayIndexConfigurator','message-service/message-service','gameday-index-enums/enums/events/LoadEvents','gameday-index-enums/enums/events/SponsorshipEvents','./subcomponents/AdvertisingUtils','message-service/message-service','app-console/app-console','./subcomponents/GDIndexAdUnit','doubleclick/interstitial'],function(require, exports, module) {
	// require imports
	var $ = require("jquery"),
		BaseClass = require("gameday-index-component-base/GDIndexComponentBase"),
		Configs = require("gameday-index-configurator/GamedayIndexConfigurator"),
		dispatcher = require("message-service/message-service"),
		LoadEvts = require("gameday-index-enums/enums/events/LoadEvents"),
		AdEvents = require("gameday-index-enums/enums/events/SponsorshipEvents"),
		AdUtils = require("./subcomponents/AdvertisingUtils"),
		MessageService = require("message-service/message-service"),
		logg = require("app-console/app-console"),
		AdUnit = require("./subcomponents/GDIndexAdUnit"),
		ist = require("doubleclick/interstitial");

	// instance variables
	var Superclass,
		pageUnits = {},
		refreshRate = 60000,
		refreshInterval,
		numAds = 0,
		adPixel;

	function GDAds(compID, divID) {
		this.componentID = compID;
		this.targetDiv = divID;
		this.init();
	}

	BaseClass.spawn(GDAds).define({
		init: function() {
			var self = this;
			this.buildAppSettings();

			MessageService.one("game_data_initialized", stageTwo);
			MessageService.addListener.call(this, AdEvents.refreshPageAds, this.writeAdPixel);

			function stageTwo() {
				self.drawAds();
				self.startRefreshTimer();
				AdUtils.enableCriteo();
				self.setWindowAccess();
				self.writeAdPixel();
				self.initialized = true;
				dispatcher.publish(AdEvents.displayInsterstitalRoadblock);
			}

			dispatcher.publish(LoadEvts.componentReady, this.componentID);
		},

		buildAppSettings: function() {
			pageUnits = Configs.getAdDefs();
			refreshRate = Configs.getAdRefreshRate() * 1000;
			window.GDApp = {};

			adPixel = document.createElement("div");
			$(adPixel).css({
				"width": "1px",
				"height": "1px",
				"overflow": "hidden"
			});


			$(adPixel).attr("id", "adPix");
			$(adPixel).appendTo("body");
		},

		drawAds: function() {
			for (var ad in pageUnits) {
				numAds++;
				nxt = pageUnits[ad];

				new AdUnit(nxt, numAds).init();
			}
		},

		startRefreshTimer: function() {
			refreshInterval = setInterval(this.refreshAds, refreshRate);
		},

		stopRefreshTimer: function() {
			refreshInterval = false;
		},

		refreshAds: function() {
			dispatcher.publish(AdEvents.refreshPageAds);
		},

		writeAdPixel: function() {

			var dblClickScriptTag = document.createElement('iframe');
			crtg_content = AdUtils.getCrtgContent(); /* Criteo, defined above */

			var dc_site,
				dc_lang = "en",// TODO: MAKE DYNAMIC
				dc_section = "gameday",// window.section || "empty",  // section is defined in page wrapper // TODO: Get from CONFIG
				dc_keyValPairs = AdUtils.getKeyVals(),//.substr(0, 30),
				dc_size = "1x2", //w + "x" + h,
				dc_adtest = '', // get frop
				writeOverlay = false, // TODO: parameterize
				ad_url;

			dc_site = (dc_lang !== "en") ? dc_lang + "." + "mlb.mlb" : "mlb.mlb"; // TODO: clubs?
			// dc_tiles[dc_size] = (dc_tiles[dc_size]) ? dc_tiles[dc_size] + 1 : 1;
			ad_url = "http://ad.doubleclick.net/N2605/adj/" + dc_site + "/" + dc_section + ";" + dc_adtest + crtg_content + dc_keyValPairs;


			ad_url += ";dcopt=ist;";
			ad_url += "page=" + "gameday" + ";"; // TODO Dynamicize
			ad_url += "pos=" + 1 + ";";//dc_tiles[dc_size] + ";";
			ad_url += "sz=" + dc_size + ";";
			ad_url += "tile=" + "1;"; // TODO Dynamicize
			ad_url += "branding=true;"; // TODO Dynamicize
			ad_url += "ord=" + Math.round(Math.random() * 1000000000) + "?";

			ad_url = escape(ad_url);

			$(adPixel).empty();
			dblClickScriptTag.async = true;
			dblClickScriptTag.src = "/gameday/wrapper/v2/RC1/subcomponents/adFrame.html" + "#adURL=" + ad_url;
			$(dblClickScriptTag).appendTo(adPixel);
		},

		setWindowAccess: function() {
			window.setRails = function(adObj) {
				var adProps = {
						bgColor: adObj.bgColor || '#000000',
						bgPosition: adObj.bgPosition || '',
						bgRepeat: adObj.bgRepeat || 'no-repeat',
						bgAttachment: adObj.bgAttachment || 'scroll',
						clickHref: adObj.clickHref || null,
						clickTarget: adObj.clickTarget || '_blank',
						clickHeight: adObj.clickHeight || '900px',
						clickTop: adObj.clickTop || '0'
				};

				var leftRail = $.extend({}, adProps, {
						img: (adObj.leftImage) ? 'url(' + adObj.leftImage + ')' : 'none',
						targetID: (adObj.leftRail) ? $(adObj.leftRail) : 'leftRailAdTag'
					}),
					rightRail = $.extend({}, adProps, {
						img: (adObj.rightImage) ? 'url(' + adObj.rightImage + ')' : 'none',
						targetID: (adObj.rightRail) ? $(adObj.leftRail) : 'rightRailAdTag'
					});

				dispatcher.publish(AdEvents.refreshAdImage, leftRail);
				dispatcher.publish(AdEvents.refreshAdImage, rightRail);
			},

			window.GDApp.displayBranding = function(adObj) {
				var adProps = {
						bgColor: adObj.bgColor || '#000000',
						bgPosition: '',
						bgRepeat: adObj.bgRepeat || 'no-repeat',
						bgAttachment: adObj.bgAttachment || 'scroll',
						clickHref: adObj.clickHref || null,
						clickTarget: adObj.clickTarget || '_blank',
						clickHeight: adObj.clickHeight || '100%',
						clickTop: adObj.clickTop || '0'
				};

				var branding = adObj.scoreboard && $.extend({}, adProps, {
						img: 'url(' + adObj.scoreboard.image + ')',
						clickHref: adObj.scoreboard.clickthru,
						target: '_blank'
					}),
					sponsor = adObj.header && $.extend({}, adProps, {
						img: 'url(' + adObj.header.image + ')',
						clickHref: adObj.header.clickthru,
						targetID: 'sponsorAdTag'
					});

				if (sponsor) {
					dispatcher.publish(AdEvents.refreshAdImage, sponsor);
				}

				if (branding) {
					dispatcher.publish(AdEvents.updateChyronAds, branding);
				}
			}
		}
	});

	Superclass = GDAds.superclass;
	return GDAds;
});

// http://ad.doubleclick.net/N2605/adj/mlb.mlb/gameday;team=pit;team=phi;gid=2015_05_11_pitmlb_phimlb_1;;dcopt=ist;page=gameday;pos=1;sz=1x1;tile=2;ord=525773001?
// http://ad.doubleclick.net/N2605/adj/mlb.mlb/gameday;gid=2015_05_11_pitmlb_phimlb_1;branding=true;dcopt=ist;page=gameday;pos=1;sz=1x2;tile=1;ord=213858519?
// http://mlb.mlb.com/mlb/gameday/branding_interstitial_ad.html;
